<template>
    <v-container class="max-container">
        <!--HISTORIC-TABLE-->
            <v-row class="historic__row">
                <v-col class="historic__row__col no-pd" cols="12">
                    <v-sheet class="historic__row__col__sheet" elevation="3">
                        <v-container class="container--table__historic">
                            <v-row class="historictable__row__tablehead">
                                <v-col class="historictable__row__tablehead__col col--padding" cols="2">
                                    <v-skeleton-loader class="historictable__row__tablehead__col__headcell" type="text"/>
                                </v-col>
                                <v-col class="historictable__row__tablehead__col--1" cols="2">
                                    <v-skeleton-loader class="historictable__row__tablehead__col__headcell" type="text"/>
                                </v-col>
                                <v-col class="historictable__row__tablehead__col--2" cols="4">
                                    <v-skeleton-loader class="historictable__row__tablehead__col__headcell" type="text"/>
                                </v-col>
                                <v-col class="historictable__row__tablehead__col--3 col--padding" cols="3">
                                    <v-skeleton-loader class="historictable__row__tablehead__col__headcell" type="text"/>
                                </v-col>
                            </v-row>
                            <v-divider class=""/>
                            <v-row class="historictable__row__tablebody">
                                <v-col class="historictable__row__tablebody__col" cols="2">
                                    <v-skeleton-loader class="historictable__row__tablebody__bodycell" v-for="n in 6" :key="n" type="text"/>                                                                        
                                </v-col>
                                <v-col class="historictable__row__tablebody__col__1" cols="2">
                                    <v-skeleton-loader class="historictable__row__tablebody__bodycell__1" v-for="n in 6" :key="n" type="text"/>                                    
                                </v-col>
                                <v-col  cols="4">
                                    <v-skeleton-loader class="historictable__row__tablebody__bodycell__2" v-for="n in 6" :key="n" type="text"/>                                    
                                </v-col>
                                <v-col cols="3">
                                    <v-skeleton-loader class="historictable__row__tablebody__bodycell__2" v-for="n in 6" :key="n" type="text"/>                                    
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-sheet>
                </v-col>
            </v-row>
        <!--END-HISTORIC-TABLE-->
    </v-container>
</template>

<script>
export default {
    name: 'historicLoader'

}
</script>

<style scoped>
    .historictable__row__tablehead__col {
        display: flex;
        flex: auto !important;
        align-items: center;
        justify-content: center;
    }
    .historictable__row__tablehead__col__headcell {
        width: 70px;
    }
    .container--table__historic {
        padding: 28px;
    }
    .historic__row__col__sheet {
        display: flex;
        flex: auto !important;
        flex-direction: column;
        color: white;
        height: 100%;
        border-radius: 14px !important;
    }
    .historictable__row__tablehead {
        display: flex;
        flex: auto !important;
        flex-direction: row;
    }
    .historictable__row__tablebody__col {
        display: flex;
        flex: auto !important;
        flex-direction: column;
        align-items: center;
    }
    .historictable__row__tablebody__bodycell {
        width: 50px;
        margin-top: 6px;
    }
    .historictable__row__tablebody__col__1 {
        display: flex;
        flex: auto !important;
        flex-direction: column;
    }
    .historictable__row__tablebody__bodycell__1 {
        margin-top: 6px;
    }
    .historictable__row__tablebody__bodycell__2 {
        margin-top: 6px;
    }
    .col--padding {
        padding: 12px;
    }
    /*RESPONSIVIDADE*/
    @media(max-width: 944px) {
        .historic__row {
            width: 100% !important;
        }
        .historictable__row__tablehead__col__headcell {
            width: 40px;
        }
        .historictable__row__tablehead__col {
            min-width: 50px;
        }
        .historictable__row__tablehead__col--1 {
            min-width: 50px;
        }
        .historictable__row__tablehead__col--2 {
            min-width: 50px;
        }
        .historictable__row__tablehead__col--3 {
            min-width: 50px;
        }
    }
    @media(max-width: 450px) {
        .col--padding {
            padding-left: 0px;
        }
    }
    /*END-RESPONSIVIDADE*/
</style>